export default __webpack_public_path__ + "locales/sl/SingleSignOn.json?hash=655082eb863fb81d1e6da39927aa4ad1";